import * as R from "remeda";
import { ChatBotTestChatRecord, DeleteAllChatBotTestChatRecord, DeleteChatBotTestChatRecord, UpdateChatBotTestChatRecordTitle, useChatBotTestChatRecords, useChatBotTestChatRecordsCount } from '@/Stores/ChatBotTest';
import { ActionIcon, Button, Divider, Group, ScrollArea, Stack, Text } from '@mantine/core';
import { IconFilePlus, IconPencil, IconTrash } from "@tabler/icons-react";
import { modals } from "@mantine/modals";
import { TimestampToDate } from "@/Helpers/DateHelper";
import { useState } from "react";

export function ChatBotTestList(props: { id: string, selectRecordId?: string, onDeselect?: () => void, onSelect?: (record: ChatBotTestChatRecord) => void }) {
    const PAGE_SIZE = 20
    const [dataLimit, setDataLimit] = useState(PAGE_SIZE)
    const data = useChatBotTestChatRecords(props.id, 0, dataLimit)
    const total = useChatBotTestChatRecordsCount(props.id) ?? 0

    return <Stack miw={150} gap={10} h="calc(100vh - 60px - var(--mb-padding, var(--mantine-spacing-md)))">
        <Button variant="subtle" onClick={props.onDeselect} justify="start" leftSection={<IconFilePlus />}>
            新聊天
        </Button>
        <Button variant="subtle" color="red" justify="start" leftSection={<IconTrash />} onClick={() => {
            modals.openConfirmModal({
                title: '刪除聊天',
                centered: true,
                children: (
                    <Text size="sm">
                        是否要刪除全部聊天?
                    </Text>
                ),
                labels: { confirm: '刪除', cancel: "取消" },
                confirmProps: { color: 'red' },
                onConfirm: () => DeleteAllChatBotTestChatRecord(props.id),
            });
        }}>
            刪除全部聊天
        </Button>
        <Divider label="聊天" />
        <ScrollArea offsetScrollbars flex={1}>
            <Stack gap={5} >
                {R.sortBy(data ?? [], (value) => -(value.updatedTimestamp ?? 0)).map((record, idx) =>
                    <Group key={record.recordId} w="100%" gap={5}>
                        <Button flex={1} h={50} variant="subtle" bg={`${record.recordId == props.selectRecordId ? "var(--mantine-primary-color-light-hover)" : ""}`} justify="start" onClick={() => {
                            props.onSelect?.(record)
                        }}>
                            <Stack gap={0}>
                                <Text truncate="end" size="md" ta="start">
                                    {record.title ? record.title : R.last(record.histories ?? [])?.requestText ?? "None"}
                                </Text>
                                <Text c="dimmed" size="sm" ta="start">
                                    {TimestampToDate(record.updatedTimestamp ?? 0).toLocaleString()}
                                </Text>
                            </Stack>
                        </Button>
                        <ActionIcon variant="subtle" onClick={() => {
                            modals.openContextModal({
                                modal: "TextInput",
                                title: "修改標題",
                                innerProps: {
                                    initText: record.title,
                                    onConfirm: async v => {
                                        UpdateChatBotTestChatRecordTitle(record.recordId, v)
                                    }
                                }
                            })
                        }}>
                            <IconPencil style={{ width: '70%', height: '70%' }} stroke={1.5} />
                        </ActionIcon>
                        <ActionIcon variant="subtle" color="red" onClick={() => {
                            modals.openConfirmModal({
                                title: '刪除聊天',
                                centered: true,
                                children: (
                                    <Text size="sm">
                                        是否要刪除此聊天?
                                    </Text>
                                ),
                                labels: { confirm: '刪除', cancel: "取消" },
                                confirmProps: { color: 'red' },
                                onConfirm: () => DeleteChatBotTestChatRecord(record.recordId),
                            });
                        }}>
                            <IconTrash style={{ width: '70%', height: '70%' }} stroke={1.5} />
                        </ActionIcon>
                    </Group>
                )}
                {dataLimit < total &&
                    <Button variant="light" size="compact-md" onClick={() => {
                        setDataLimit(x => x + PAGE_SIZE)
                    }}>載入更多</Button>
                }
            </Stack>
        </ScrollArea>
    </Stack>
}